/* eslint-disable */
// 入口文件导入polyfill
import 'core-js';
import 'regenerator-runtime/runtime';

import React, { useEffect } from 'react'
import { createRoot, hydrateRoot } from 'react-dom/client'
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { AppContextComponent, createRequestContext } from '@cap/ssr-common-utils';
import { getReqCtx, sandboxStorageWrapper } from '@cap/ssr-common-utils/internal';

import Entry from '/opt/jenkins/workspace/8170171-capfe-mtdx-client-mono-production/packages/web/src/index.tsx';

const DefaultApp = (props) => {
  const { children } = props;
  return <React.Fragment>{children}</React.Fragment>;
}

const DefaultStoreProvider = ({ children }) => {
  return <> {children} </>;
};

const {
  App = DefaultApp,
  clientPrefix = '',
  routes, serverPrefix = '',
  onBootstrap = ()=>{},
  reducer = (state) => state,
  Store,
} = Entry

const useSSR = !!window.__USE_SSR__;

const clientRender = async () => {
  const { Provider: StoreProvider = DefaultStoreProvider, ...storeProps } = Store || {};

  const ele =(
    <StoreProvider { ...storeProps}>
      <BrowserRouter basename={useSSR ? serverPrefix : clientPrefix}>
        <AppContextComponent reducer={reducer}>
          <App>
            <Switch>
              {routes.map((item) => {
                const { component: Component, path, exact= false } = item;
                return <Route exact={exact} key={path} path={path} render={() => <Component />} />;
              })}
            </Switch>
          </App>
        </AppContextComponent>
      </BrowserRouter>
    </StoreProvider>);

  try {
    const ctx = getReqCtx();
    await onBootstrap(ctx);
  } finally {
    const container = document.querySelector('#root');
    if (useSSR) {
      hydrateRoot(container, ele);
    } else {
      const root = createRoot(container);
      root.render(ele);
    }
  }
}

sandboxStorageWrapper.run(
  {
    // mock 请求上下文，进行缓存，方便子流程中统一使用。
    ctx: createRequestContext(),
  },
  () => {
    
    clientRender()
    
  },
);
